import { render, staticRenderFns } from "./drag-drop-upload-file.vue?vue&type=template&id=286a680f&scoped=true&"
import script from "./drag-drop-upload-file.vue?vue&type=script&lang=js&"
export * from "./drag-drop-upload-file.vue?vue&type=script&lang=js&"
import style0 from "./drag-drop-upload-file.vue?vue&type=style&index=0&id=286a680f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286a680f",
  null
  
)

export default component.exports